import styled from 'styled-components'
import { Colors, Row, SimpleTooltip } from '@microfrontends/react-components'

export const CompanionBusinessContainer = styled(Row)`
	margin-bottom: 48px;
`

export const TitleSubText = styled.p`
	margin: 5px 0 0;
	font-size: 10px;
	font-weight: 400;
`

export const CompanionBusinessCardWrapper = styled.div`
	display: inline-flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 6px;
`

export const CompanionBusinessCardElement = {
	Container: styled.a`
		height: 100%;
		border: 1px solid #e9e9e9;
		background-color: #fff;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		padding: 10px;
		text-align: center;
		transition: box-shadow 0.25s ease-in-out;
		color: ${Colors.text};
		&:hover {
			box-shadow: 30px 32px 17px rgba(0, 0, 0, 0.01),
				17px 18px 15px rgba(0, 0, 0, 0.05),
				7px 8px 11px rgba(0, 0, 0, 0.09), 2px 2px 6px rgba(0, 0, 0, 0.1),
				0px 0px 0px rgba(0, 0, 0, 0.1);
		}
	`,
	CompanyName: styled.p`
		margin-top: 5px;
		margin-bottom: 0;
		font-size: 12px;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
	`,
	Tooltip: styled(SimpleTooltip)<{
		numsOfItem: number
	}>`
		width: ${({ numsOfItem }) => `calc(100% / ${numsOfItem} - 6px)`};
	`,
	TooltipContainer: styled.div`
		padding: 32px 16px;
		font-size: 14px;
	`,
	TooltipContent: styled.div`
		max-height: 250px;
		overflow-y: auto;
	`
}
